namespace $.$$ {

	$mol_style_define( $shm_projects_configuration, {

		flex: { basis: '48rem', grow: 0, shrink: 1 },
		width: '48rem',
		maxWidth: '100%',

		Form: {
			minWidth: 0,
			padding: $mol_gap.block,
			Body: {
				gap: $mol_gap.block,
			},
		},

		Tree: {
			margin: 0,
			width: '100%',
			maxWidth: '100%',
		},

		Session_directory_field: { width: '100%' },
		Session_agents_field: { width: '100%' },

		Node: {
			width: '100%',
			minWidth: 0,
		},

		Node_title: {
			padding: $mol_gap.text,
			font: { weight: 'bold' },
		},

		Text_field: { width: '100%' },
		Number_field: { width: '100%' },
		List_field: { width: '100%' },

	} )

}
